export default {
  namespaced: true,
  presets_ptz: {
    title: "preset | presets",
    id_camera: "id camera",
    presets: "presets",
  },
}
